// extracted by mini-css-extract-plugin
module.exports = {"button3":"DeleteProduct_button3__13VhY","selectCategory":"DeleteProduct_selectCategory__1pdNu","label":"DeleteProduct_label__3KjdG","General":"DeleteProduct_General__13wGA"};